<template>
    <b-row>
        <b-col lg="12" xl="12" xxl="12">
            <b-container fluid class="pe-0">
                <b-row>
                    <b-row class="overall-bg">
                        <b-col sm="12" md="8">
                            <ItemDetails :dataObj="insert_data" />
                            <!-- {{ Unitoftransactions }} -->
                            <UnitOfTransaction :dataObj="Unitoftransactions" />
                            <Grouping :dataObj="Grouping" />
                            <GenericandManufacturing :dataObj="insert_data" />
                        </b-col>
                        <b-col sm="12" md="4">
                            <ImagePreview :PorpsImageList="PorpsImageList" />
                            <PurchaseInfo :dataObj="insert_data" />
                            <b-row>
                                <b-col sm="6" md="6">
                                    <UnitTransaction :dataObj="SpecialCategory" />
                                </b-col>
                                <b-col sm="6" md="6">
                                    <Configuration :dataObj="Configuration" />
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-row>
            </b-container>
        </b-col>
    </b-row>
</template>
<script lang="ts">
// import Headerlayout from "../../../../../../../components/Masters/HeaderLayout.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import { defineComponent, ref, h, computed, onMounted, watch } from "vue";
import Details from "../../../../../modules/Inventory/components/MasterDetails/Details.vue";
import ItemDetails from '../../../../../modules/Inventory/components/MasterDetails/ItemDetails.vue';
import GenericandManufacturing from '../../../../../modules/Inventory/components/MasterDetails/GenericandManufacturing.vue';
import Grouping from '../../../../../modules/Inventory/components/MasterDetails/Grouping.vue';
import UnitTransaction from '../../../../../modules/Inventory/components/MasterDetails/UnitTransaction.vue';
import Configuration from '../../../../../modules/Inventory/components/MasterDetails/Configuration.vue'
import ImagePreview from '../../../../../modules/Inventory/components/MasterDetails/ImagePreview.vue';
import PurchaseInfo from '../../../../../modules/Inventory/components/MasterDetails/ItemPurchaseInfo.vue';
import UnitOfTransaction from '../../../../../modules/Inventory/components/MasterDetails/UnitOfTransaction.vue';
import service from "./../../../Service/ItemMasService";
import common from "../../../../../modules/Inventory/Service/CommonService"


export default defineComponent({
    components: {
        Details,
        ItemDetails,
        Grouping,
        GenericandManufacturing,
        ImagePreview,
        PurchaseInfo,
        UnitTransaction,
        Configuration,
        UnitOfTransaction
    },

    setup() {
        const router = useRouter();
        const routers = useRoute();
        const ParamValues = ref({
            itemid: 0,
        });
        onMounted(() => {
            init();

        })
        let itemid = routers.query.id;
        ParamValues.value.itemid = Number(itemid);
        watch(
            () => routers.query.id,
            (newVal: any) => {
                debugger;

                ParamValues.value.itemid = Number(newVal);
                init();
            }
        );
        let session: any = localStorage.getItem("UsersData");
        session = JSON.parse(session);
        let HospitalId = Number(session.OrganizationId);
        let insert_data = ref({
            CreatedAt: "",
            CreatedBy: 0,
            ModifiedBy: 0,
            ModifiedAt: "",
            HospitalId: 0,
            BranchId: 0,
            Id: 0,
            Code: "",
            ProductId: "",
            Name: "",
            HSNId: ref(),
            PurchasePrice: ref(),
            MRP: ref(),
            MarkupPercentage: ref(),

            StandardRate: 0,
            SalesPrice: ref(),
            VatOn: "",
            IsNoBarcode: true,
            ScheduledInvItemId: 0,
            IsCAPEX: true,
            EntityId: 0,
            EntityOperationId: 0,
            ManufactureName: "",
            ItemGenericName: "",
            HSNCode: ""
        });

        const Unitoftransactions: any = ref({
            PackSizeId: ref(),
            OrderUnitId: ref(),
            UnitId: ref(),
            DispenseInNumber: true,

            OrderUnitName: ref(),
            UnitName: ref(),

            PackageSizeName: '',

        });

        const Grouping: any = ref({
            ItemTypeId: ref(),
            ItemGroupId: ref(),
            SubGroupId: ref(),
            ProductId: ref(),
            ItemCategoryName: ref(),
            ItemCategoryId: 0,
            ItemGroupName: ref(),
            ItemSubGroupName: ref()
        });

        const Manufacturing: any = ref({
            ManufatureId: ref(),
        });

        const Generic: any = ref({
            GenericId: ref(),
        });

        const SpecialCategory: any = ref({
            ScheduledItem: false,
            NarcoticItem: false,
            DrugFormulary: false,
            CriticalMedicine: false,
            Alike: false,
            SpecialCategoryItemId: ref() ?? 0,
        });
        let PorpsImageList: any = ref([])

        const Configuration: any = ref({
            ExpiryDtRequired: false,
            BatchRequired: false,
            IsNonChargable: false,
            IsConsignee: false,
            NoMrp: false,
            AutoConsumed: false,
            HighValueFlag: false,
            IsxrayFilm: false,
            IsGSTExempt: false,
            Asset: false,
            ConfigValue: "",
            ServiceLevel: false,
        });

        async function init() {
            debugger;
            console.log(ParamValues.value.itemid);
            if (ParamValues.value.itemid !== undefined && !isNaN(ParamValues.value.itemid)) {
                try {
                    // label.value = "Update";
                    const EditID = ParamValues.value.itemid;
                    console.log(EditID);
                    try {
                        // loading.value = true;

                        const data_response = await service.Edit(EditID, HospitalId);
                        const data1 = data_response["result"];
                        console.log(data_response["result"]);

                        Object.keys(insert_data.value).forEach((key) => {
                            if (data1[key]) insert_data.value[key] = data1[key];
                        });

                        Object.keys(Unitoftransactions.value).forEach((key) => {
                            if (data1[key]) Unitoftransactions.value[key] = data1[key];
                        });

                        Object.keys(Grouping.value).forEach((key) => {
                            if (data1[key]) Grouping.value[key] = data1[key];
                        });
                        // ProductTypeId.value = Grouping.value.ItemTypeId;
                        Object.keys(Manufacturing.value).forEach((key) => {
                            if (data1[key]) Manufacturing.value[key] = data1[key];
                        });

                        Object.keys(Generic.value).forEach((key) => {
                            if (data1[key]) Generic.value[key] = data1[key];
                        });

                        // Object.keys(SpecialCategory.value).forEach((key) => {
                        //   if (data1[key]) SpecialCategory.value[key] = data1[key];
                        // });

                        Object.keys(SpecialCategory.value).forEach((key) => {
                            if (key == "ScheduledItem") {
                                if (data1.ScheduledItem == true) {
                                    data1.ScheduledItem = ["true"];
                                } else {
                                    data1.ScheduledItem = [];
                                }
                            } else if (key == "NarcoticItem") {
                                if (data1.NarcoticItem == true) {
                                    data1.NarcoticItem = ["true"];
                                } else {
                                    data1.NarcoticItem = [];
                                }
                            } else if (key == "DrugFormulary") {
                                if (data1.DrugFormulary == true) {
                                    data1.DrugFormulary = ["true"];
                                } else {
                                    data1.DrugFormulary = [];
                                }
                            } else if (key == "CriticalMedicine") {
                                if (data1.CriticalMedicine == true) {
                                    data1.CriticalMedicine = ["true"];
                                } else {
                                    data1.CriticalMedicine = [];
                                }
                            } else if (key == "Alike") {
                                if (data1.Alike == true) {
                                    data1.Alike = ["true"];
                                } else {
                                    data1.Alike = [];
                                }
                            }
                            if (data1[key]) SpecialCategory.value[key] = data1[key];
                        });

                        // Object.keys(Configuration.value).forEach((key) => {
                        //   if (data1[key]) Configuration.value[key] = data1[key];
                        // });

                        Object.keys(Configuration.value).forEach((key) => {
                            if (key == "ExpiryDtRequired") {
                                if (data1.ExpiryDtRequired == true) {
                                    data1.ExpiryDtRequired = ["true"];
                                } else {
                                    data1.ExpiryDtRequired = [];
                                }
                            } else if (key == "BatchRequired") {
                                if (data1.BatchRequired == true) {
                                    data1.BatchRequired = ["true"];
                                } else {
                                    data1.BatchRequired = [];
                                }
                            } else if (key == "IsNonChargable") {
                                if (data1.IsNonChargable == true) {
                                    data1.IsNonChargable = ["true"];
                                } else {
                                    data1.IsNonChargable = [];
                                }
                            } else if (key == "IsConsignee") {
                                if (data1.IsConsignee == true) {
                                    data1.IsConsignee = ["true"];
                                } else {
                                    data1.IsConsignee = [];
                                }
                            } else if (key == "NoMrp") {
                                if (data1.NoMrp == true) {
                                    data1.NoMrp = ["true"];
                                } else {
                                    data1.NoMrp = [];
                                }
                            } else if (key == "AutoConsumed") {
                                if (data1.AutoConsumed == true) {
                                    data1.AutoConsumed = ["true"];
                                } else {
                                    data1.AutoConsumed = [];
                                }
                            } else if (key == "HighValueFlag") {
                                if (data1.HighValueFlag == true) {
                                    data1.HighValueFlag = ["true"];
                                } else {
                                    data1.HighValueFlag = [];
                                }
                            } else if (key == "IsxrayFilm") {
                                if (data1.IsxrayFilm == true) {
                                    data1.IsxrayFilm = ["true"];
                                } else {
                                    data1.IsxrayFilm = [];
                                }
                            } else if (key == "IsGSTExempt") {
                                if (data1.IsGSTExempt == true) {
                                    data1.IsGSTExempt = ["true"];
                                } else {
                                    data1.IsGSTExempt = [];
                                }
                            } else if (key == "Asset") {
                                if (data1.Asset == true) {
                                    data1.Asset = ["true"];
                                } else {
                                    data1.Asset = [];
                                }
                            } else if (key == "ServiceLevel") {
                                if (data1.ServiceLevel == true) {
                                    data1.ServiceLevel = ["true"];
                                } else {
                                    data1.ServiceLevel = [];
                                }
                            }

                            if (data1[key]) Configuration.value[key] = data1[key];
                        });
                        const ProductImageResponse = await common.GetProductImageByItemId(EditID);
                        debugger
                        for (let item of ProductImageResponse["result"]) {
                            PorpsImageList.value.push(item['ImageFile'])
                        }

                        // loading.value = false;
                    } catch (error) {
                        // loading.value = false;
                        alert(error);
                    }
                } catch (error) {
                    console.error(error);
                }
            } else {
            }
        }

        return {
            insert_data,
            Unitoftransactions,
            Grouping,
            Manufacturing,
            Generic,
            SpecialCategory,
            Configuration,
            PorpsImageList
        };
    },
});
</script>